/* eslint-disable import/no-unresolved */
import AuditLogsColumnConfig from 'views/Rules/common/AuditLogsColumnConfig';
import Metro2AuditLogs from '../components/Metro2AuditLogs';

const Metro2AuditLog = ({ data }) => {
    const metro2Columns = AuditLogsColumnConfig;

    return (
        <Metro2AuditLogs
            data={data}
            columns={metro2Columns}
        />
    );
};

export default Metro2AuditLog;
